'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  width: '14px',
  height: '14px',
  fontSize: '14px',
  lineHeight: '14px',
  textAlign: 'center',
  transition: 'color .2s ease',
  border: 'none',
  backgroundColor: 'white',
  '& .inner': {
    width: '14px'
  },
  '& i:hover': {
    transition: 'transform .1s',
    transform: 'rotate(45deg)'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(_ref, theme) {
  var disabled = _ref.disabled,
      loading = _ref.loading;

  var styles = (0, _extends3.default)({
    color: theme.colors.tertiary
  }, (0, _objectResolvePath2.default)(theme, 'RefreshButton.css') || {});

  if (!disabled && !loading) {
    styles['&:hover'] = { color: 'black' };
  }

  return styles;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/buttons/RefreshButton/RefreshButton.style.js
// module id = 370
// module chunks = 0